export default __webpack_public_path__ + "static/media/paul.501f38fe.jpg";